
export interface ISearchResultDTO {
    searchTerm: string;
    results: ISearchResultHitDTO[];
    facets: IFacetDTO[];
    didYouMean: string;
    totalResults: number;
    trackingId: string;
    defaultSort: string;
    context: string;
    showUrl: boolean;
}

export interface ISearchResultHitDTO {
    title: string;
    url: string;
    description: string;
    categories: string[];
    fileType: string;
    hitId: string;
    isBestBet: string;
    address: string;
    phoneNumber: string;
    gradesOffered: string;
    mapLinkUrl: string;
    isGoCPSParticipant: boolean;
    studentCount: number;
    network: string;
    adaAccessibility: string;
    hasDressCode: boolean;
    searchResultType: ResultTypeEnum;
    id: number;
    programs: string[];
    programTypes: string[];
    governance: string;
    rating: string;
    campusAccessibility: string;
    parkingAccessibility: string;
    isPublic?: boolean;
}

export enum ResultTypeEnum {
    Default,
    School
}

export interface IFacetDTO {
    fieldName: string;
    displayName: string;
    facetDisplayOption: FacetDisplayOption[];
    showMoreAmount: number;
    terms: ITermDTO[];
}

export interface ITermDTO {
    id: number;
    displayName: string;
    fieldName: string;
    term: string;
    hits: number;
    selected: boolean;
    icon: TermIcon;
}

export enum TermIcon {
    PDF,
    WebPage
}

export enum FacetDisplayOption {
    Checkbox,
    Dropdown
}

export interface ISearchRequestDTO {
    searchTerm: string;
    pageSize: number;
    pageNumber: number;
    facets: IFacetDTO[];
    context: string;
    sortField: number;
    sortDirection: number;
    dateSortRelevanceFilter: number;
    contentId: string;
}

export interface IAutocompleteResults {
    hits: IHit[];
    activeHit: number;
    isActive: boolean;
}

export const DefaultAutoCompleteResults: IAutocompleteResults = Object.freeze({
    hits: [],
    activeHit: -1,
    isActive: false,
})



export interface IHit {
    query: string;
    type: string;
}

export interface ITrackClick {
    searchTerm: string;
    trackingId: string;
    hitId: string;
}

export const FILE_EXTENSION_TERM: string = "SearchFileExtension";